/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useRef, useState, useEffect } from 'react';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import ServiesImg from '../../assets/services.svg';
import Footer from './Footer';

const Services = props => {

    // contexts
    const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // useEffects
    useEffect(() => {
        setIsLoading(true);
        try {
            GeneralService.getServices().then(data => {
                setServices([...data.services]);
                setIsLoading(false);
            })
        } catch (err) {
            console.log(err);
        }
    }, []);

    // handle functions
    const handleClick = (e, item) => {
        e.preventDefault();

        props.history.push(`/service?id=${item._id}`);
    }

    //utility function

    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At General Services GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>

            <div className="row p-3 px-5" style={{ background: "rgba(184, 247, 255, 0.3)" }}>
                <div className="col-md-8 col-12 mt-5">
                    <h1 id="services-heading" className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>Services</h1>
                    <p id="desc-para" style={{ fontSize: "1.2rem", maxWidth: "400px" }}>
                        We provide special services apart from the counselling sessions from our Counsellors.
                        <br />
                        These services are best suited for a group session at any organisation/institution.
                    </p>
                </div>
                <img className="col-md-4 col-12" src={ServiesImg} alt="img" />
            </div>

            <div className='row p-5'>
                {services.map((item, index) => (
                    <div key={index} className='col-md-4 col-12 mb-5'>
                        <div className='p-3' style={{ border: 'solid 3px #384E73', height: "100%" }}>
                            <h2 style={{ color: colors.primary }}>{item.name}</h2>
                            <p>
                                {item.overview}
                            </p>
                            <p className='d-flex float-right align-items-end p-3' onClick={(e) => handleClick(e, item)} style={{ cursor: "pointer" }} >
                                <i className="fas fa-long-arrow-alt-right " style={{ fontSize: "1.7rem", color: "#384E73" }}></i>
                            </p>
                        </div>
                    </div>
                ))}
            </div>
            <Footer />
        </div>
    )

}

export default Services;